export enum WidgetHeaderItemSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  BIG = 'big',
}
